import { combineReducers } from '@reduxjs/toolkit'

import { calendarReducer, CalendarState } from './@interface/calendar/calendarReducer'
import { absencesReducer, AbsencesState } from './absences/absencesLegacyReducer'
import { absencesReducer as pacoAbsenceReducer, AbsencesState as PacoAbsencesState } from './absences/absencesReducer'
import { appReducer, AppState } from './app/appLegacyReducer'
import { appReducer as pacoAppReducer, AppState as PacoAppState } from './app/appReducer'
import { authenticationReducer, AuthenticationState } from './authentication/authenticationReducer'
import { chatUsersReducer, ChatUsersState } from './chatUsers/chatUsersReducer'
import { documentsReducer, DocumentsState } from './documents/documentsReducer'
import { exchangesReducer, ExchangesState } from './exchanges/exchangesReducer'
import { feedbackReducer, FeedbackState } from './feedback/feedbackReducer'
import { hourBalancesReducer, HourBalancesState } from './hourBalances/hourBalancesReducer'
import { leaveOfAbsenceRequestDetailReducer as pacoLeaveOfAbsenceRequestDetailReducer, LeaveOfAbsenceRequestDetailState } from './leaveOfAbsenceRequestDetail/leaveOfAbsenceRequestDetailReducer'
import { leaveOfAbsencesRequestsReducer as pacoLeaveOfAbsencesRequestsReducer, LeaveOfAbsencesRequestsState } from './leaveOfAbsencesRequests/leaveOfAbsencesRequestsReducer'
import { notificationsReducer, NotificationsState } from './notifications/notificationsReducer'
import { preferenceReducer, PreferenceState } from './preferences/preferenceReducer'
import { registrationReducer as pacoRegistrationReducer, RegistrationState } from './registration/registrationReducer'
import { shiftReducer, ShiftState } from './shift/shiftReducer'
import { shiftsReducer, ShiftsState } from './shifts/shiftsLegacyReducer'
import { shiftsReducer as pacoShiftsReducer, ShiftsState as PacoShiftsState } from './shifts/shiftsReducer'
import { specialDaysReducer as pacoSpecialDaysReducer, SpecialDaysState } from './specialDays/specialDaysReducer'
import { toastsReducer, ToastsState } from './toasts/toastsReducer'
import { trackReducer, TrackState } from './track/trackReducer'
import { tracksReducer, TracksState } from './tracks/tracksReducer'
import { transportationOptionsReducer, TransportationOptionsState } from './transportationOptions/transportationOptionsReducer'
import { userReducer, UserState } from './user/userReducer'
import { yearEndStatementReducer, YearEndStatementsState } from './yearEndStatement/yearEndStatementReducer'

export interface Reducers {
    appReducer: AppState
    authenticationReducer: AuthenticationState
    chatUsersReducer: ChatUsersState
    tracksReducer: TracksState
    trackReducer: TrackState
    shiftsReducer: ShiftsState
    shiftReducer: ShiftState
    exchangesReducer: ExchangesState
    absencesReducer: AbsencesState
    userReducer: UserState
    feedbackReducer: FeedbackState
    documentsReducer: DocumentsState
    preferenceReducer: PreferenceState
    calendarReducer: CalendarState
    hourBalancesReducer: HourBalancesState
    pacoAppReducer: PacoAppState
    pacoRegistrationReducer: RegistrationState
    pacoShiftsReducer: PacoShiftsState
    pacoSpecialDaysReducer: SpecialDaysState
    toastsReducer: ToastsState
    transportationOptionsReducer: TransportationOptionsState
    yearEndStatementReducer: YearEndStatementsState
    pacoAbsenceReducer: PacoAbsencesState
    pacoLeaveOfAbsencesRequestsReducer: LeaveOfAbsencesRequestsState
    pacoLeaveOfAbsenceRequestDetailReducer: LeaveOfAbsenceRequestDetailState
    notificationsReducer: NotificationsState
}

export const reducers = combineReducers({
    appReducer,
    authenticationReducer,
    tracksReducer,
    trackReducer,
    shiftsReducer,
    shiftReducer,
    exchangesReducer,
    userReducer,
    absencesReducer,
    feedbackReducer,
    documentsReducer,
    preferenceReducer,
    calendarReducer,
    chatUsersReducer,
    hourBalancesReducer,
    pacoAppReducer,
    pacoRegistrationReducer,
    pacoShiftsReducer,
    pacoSpecialDaysReducer,
    toastsReducer,
    transportationOptionsReducer,
    yearEndStatementReducer,
    pacoAbsenceReducer,
    pacoLeaveOfAbsencesRequestsReducer,
    pacoLeaveOfAbsenceRequestDetailReducer,
    notificationsReducer,
})
